export const getInitialValues = (initialPropertyValue) => {
    return initialPropertyValue || {
        id: "",
        property_type_id: "",
        country: "",
        street_address: "",
        flat_suite: "",
        zone_id: "",
        city_id: "",
        state: "",
        area: "",
        post_code: "",
        phone_number: "",
        short_description: "",
        long_description: "",
        short_description_hebrew: "",
        long_description_hebrew: "",
        is_available_for_booking: "reserving",
        room_type: "single",
        price_for_weekends: "",
        weekend_discounted_price: "",
        price_for_weekdays: "",
        weekdays_discounted_price: "",
        rooms: [
            {
                numberOfBeds: "",
                size: "",
                adults: 0,
                children: 0,
                pets: 0,
            },
        ],
        facilities: [],
    };
};
